/**
 * PanelEvent — renderiza tipo 'panel'
 * payload: { voces: [ { agente, contenido, estado } ] }
 *
 * R-PT-08: voces separadas y atribuidas — NUNCA fundidas.
 *          Cada voz se muestra con su avatar y nombre claramente visibles.
 */

import { AgentAvatar } from '../AgentAvatar.jsx'

const ESTADO_LABELS = {
  completado:  { label: 'Completado', cls: 'panel-voz--done'    },
  en_curso:    { label: 'En curso',   cls: 'panel-voz--running' },
  pendiente:   { label: 'Pendiente',  cls: 'panel-voz--pending' },
}

export default function PanelEvent({ payload }) {
  const { voces = [] } = payload

  return (
    <div className="event-panel">
      <p className="event-panel__label">Varias perspectivas</p>
      <div className="event-panel__voices">
        {voces.map((voz, i) => {
          const estadoMeta = ESTADO_LABELS[voz.estado] ?? { label: voz.estado, cls: '' }
          return (
            <div key={i} className={'panel-voz ' + estadoMeta.cls}>
              <div className="panel-voz__header">
                <AgentAvatar name={voz.agente} size={28} />
                <span className="panel-voz__name">{voz.agente}</span>
                <span className="panel-voz__estado">{estadoMeta.label}</span>
              </div>
              <p className="panel-voz__content">{voz.contenido}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
